module.exports = __webpack_public_path__ + "img/Nov5G.1818300c.png";